import React from 'react'

function DivWrapper( { children } ) {
  return (

    <div className='mainWrapper'>{children} </div>
  )
}

export default DivWrapper